/*eslint-disable*/
import Flickity from 'flickity'
export default slider => {
  const leftArrow = $(slider).find('.js-carousel-left')
  const rightArrow = $(slider).find('.js-carousel-right')
  let flkty
  let flktyParams = {
    contain: true,
    prevNextButtons: false,
    wrapAround: true,
    autoPlay: false
  }
  const setFlkty = () => {
    flkty = new Flickity(slider, flktyParams)
    flkty.on('dragStart', (event, pointer) => { document.ontouchmove = e => e.preventDefault() })
    flkty.on('dragEnd', (event, pointer) => { document.ontouchmove = e => true })
    setTimeout(() => {
      flkty.resize()
    }, 1500)
    $(leftArrow).click(() => flkty.previous())
    $(rightArrow).click(() => flkty.next())
  }
  if (slider && window.matchMedia('(max-width: 863px)').matches) setFlkty()
  $(window).on('resize', () => {
    if (window.matchMedia('(max-width: 863px)').matches) {
      !flkty && setFlkty()
    } else {
      flkty && flkty.destroy()
      flkty = null
    }
  })
}



// WEBPACK FOOTER //
// ./src/scripts/components/mobile-magazine-slider-2.js